import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import thunkMiddleware from "redux-thunk";

import {
  BookingReducer,
  HomeReducer,
  LoaderReducer,
  ToastReducer,
  UserReducer,
  ViewReducer,
} from "./reducers/app";
import bookingsSlice from "./slices/bookingsSlice";
import cargoBookingSlice from "./slices/cargoBookingSlice";
import commoditiesSlice from "./slices/commoditiesSlice";
import containerTemperatureSlice from "./slices/containerTemperatureSlice";
import containerTypesSlice from "./slices/containerTypesSlice";
import customerSlice from "./slices/customerSlice";
import documentsSlice from "./slices/documentsSlice";
import hazardCodesSlice from "./slices/hazardCodesSlice";
import hsCodesSlice from "./slices/hsCodesSlice";
import incotermsSlice from "./slices/incotermsSlice";
import invoicesSlice from "./slices/invoicesSlice";
import notesSlice from "./slices/notesSlice";
import packageTypesSlice from "./slices/packageTypesSlice";
import partnerSlice from "./slices/partnerSlice";
import portsSlice from "./slices/portsSlice";
import requestsSlice from "./slices/requestsSlice";
import routeBookingSlice from "./slices/routeBookingSlice";
import shippingTypesSlice from "./slices/shippingTypesSlice";
import transactionsSlice from "./slices/transactionsSlice";
import userSlice from "./slices/userSlice";

const loggerMiddleware = createLogger();

const rootReducer = combineReducers({
  UserReducer,
  ToastReducer,
  ViewReducer,
  HomeReducer,
  BookingReducer,
  LoaderReducer,
  portsSlice,
  commoditiesSlice,
  hsCodesSlice,
  hazardCodesSlice,
  packageTypesSlice,
  containerTypesSlice,
  containerTemperatureSlice,
  incotermsSlice,
  shippingTypesSlice,
  partnerSlice,
  routeBookingSlice,
  cargoBookingSlice,
  documentsSlice,
  requestsSlice,
  invoicesSlice,
  customerSlice,
  transactionsSlice,
  bookingsSlice,
  notesSlice,
  userSlice,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return process.env.NODE_ENV === "production"
      ? getDefaultMiddleware().concat(thunkMiddleware)
      : getDefaultMiddleware().concat(loggerMiddleware).concat(thunkMiddleware);
  },
});
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
